import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "390000000000";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (!detail) return "Si è verificato un errore. Riprova tra poco.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
}
